module.exports = __webpack_public_path__ + "img/orders.12d09754.svg";